'use client';

import { c as _c } from "react/compiler-runtime";
import { Tab } from '@common/components';
import type { MedianIncomeYear } from '../constants';
import { MEDIAN_INCOME_YEARS } from '../constants';
interface YearTabsProps {
  selectedYear: MedianIncomeYear;
  onChange: (year: MedianIncomeYear) => void;
}

/**
 * 연도 선택 탭 — `MEDIAN_INCOME_YEARS` 의 키를 순회.
 * 보유 연도가 1개뿐이면 시각적 가치가 없어 숨긴다.
 */
export const YearTabs = t0 => {
  const $ = _c(4);
  const {
    selectedYear,
    onChange
  } = t0;
  if (MEDIAN_INCOME_YEARS.length < 2) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = MEDIAN_INCOME_YEARS.map(_temp);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onChange || $[2] !== selectedYear) {
    t2 = <Tab value={selectedYear} onChange={onChange} variant="flex">{t1}</Tab>;
    $[1] = onChange;
    $[2] = selectedYear;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(year) {
  return <Tab.Item key={year} value={year}>{year}년</Tab.Item>;
}